'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMultipleLimits = exports.getTableGamesSummary = exports.getLimitWithToken = exports.setLimitWithToken = exports.pgsiScore = exports.panic = exports.getProductBlocks = exports.blockProduct = exports.decline = exports.confirm = exports.toConfirm = exports.selfExclude = exports.selfBlock = exports.getRealityCheckData = exports.getRealityCheckSession = exports.deleteLimit = exports.setLimit = exports.getLimit = exports.limitIncreaseInfo = undefined;

var _responsibleGaming = require('tg-core-api/lib/responsible-gaming');

var _responsibleGaming2 = _interopRequireDefault(_responsibleGaming);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var limitIncreaseInfo = exports.limitIncreaseInfo = function limitIncreaseInfo(playerSessionID) {
  return (0, _action.makeApiCallAction)('LIMIT_INCREASE_INFO', _responsibleGaming2.default.limitIncreaseInfo(playerSessionID));
};

var getLimit = exports.getLimit = function getLimit(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_LIMIT', _responsibleGaming2.default.getLimit(playerSessionID));
};

var setLimit = exports.setLimit = function setLimit(playerSessionID, limit) {
  return (0, _action.makeApiCallAction)('SET_LIMIT', _responsibleGaming2.default.setLimit(playerSessionID, limit));
};

var deleteLimit = exports.deleteLimit = function deleteLimit(playerSessionID, limitID, score) {
  return (0, _action.makeApiCallAction)('DELETE_LIMIT', _responsibleGaming2.default.deleteLimit(playerSessionID, limitID, score));
};

var getRealityCheckSession = exports.getRealityCheckSession = function getRealityCheckSession(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_REALITYCHECK_SESSION', _responsibleGaming2.default.getRealityCheckSession(playerSessionID));
};

var getRealityCheckData = exports.getRealityCheckData = function getRealityCheckData(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_REALITYCHECK', _responsibleGaming2.default.getRealityCheckData(playerSessionID));
};

var selfBlock = exports.selfBlock = function selfBlock(playerSessionID, expiresIn) {
  return (0, _action.makeApiCallAction)('SELF_BLOCK', _responsibleGaming2.default.selfBlock(playerSessionID, expiresIn));
};
var selfExclude = exports.selfExclude = function selfExclude(playerSessionID, expiresIn) {
  return (0, _action.makeApiCallAction)('SELF_EXCLUDE', _responsibleGaming2.default.selfExclude(playerSessionID, expiresIn));
};
var toConfirm = exports.toConfirm = function toConfirm(playerSessionID) {
  return (0, _action.makeApiCallAction)('RG_TO_CONFIRM', _responsibleGaming2.default.toConfirm(playerSessionID));
};
var confirm = exports.confirm = function confirm(playerSessionID, id) {
  return (0, _action.makeApiCallAction)('RG_CONFIRM', _responsibleGaming2.default.confirm(playerSessionID, id));
};
var decline = exports.decline = function decline(playerSessionID, id) {
  return (0, _action.makeApiCallAction)('RG_DECLINE', _responsibleGaming2.default.decline(playerSessionID, id));
};

var blockProduct = exports.blockProduct = function blockProduct(playerSessionID, expiresIn, product) {
  return (0, _action.makeApiCallAction)('BLOCK_PRODUCT', _responsibleGaming2.default.blockProduct(playerSessionID, expiresIn, product));
};

var getProductBlocks = exports.getProductBlocks = function getProductBlocks(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_PRODUCT_BLOCKS', _responsibleGaming2.default.getProductBlocks(playerSessionID));
};

var panic = exports.panic = function panic(playerSessionID, panicChoice) {
  return (0, _action.makeApiCallAction)('RG_PANIC', _responsibleGaming2.default.panic(playerSessionID, panicChoice));
};

var pgsiScore = exports.pgsiScore = function pgsiScore(playerSessionID, Score) {
  return (0, _action.makeApiCallAction)('RG_PGSI', _responsibleGaming2.default.pgsiScore(playerSessionID, Score));
};

var setLimitWithToken = exports.setLimitWithToken = function setLimitWithToken(limit) {
  return (0, _action.makeApiCallAction)('SET_LIMIT_WITH_TOKEN', _responsibleGaming2.default.setLimitWithToken(limit));
};

var getLimitWithToken = exports.getLimitWithToken = function getLimitWithToken(token) {
  return (0, _action.makeApiCallAction)('GET_LIMIT_WITH_TOKEN', _responsibleGaming2.default.getLimitWithToken(token));
};

var getTableGamesSummary = exports.getTableGamesSummary = function getTableGamesSummary(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_TABLE_GAMES_SUMMARY', _responsibleGaming2.default.getTableGamesSummary(playerSessionID));
};

var setMultipleLimits = exports.setMultipleLimits = function setMultipleLimits(playerSessionID, limits) {
  return (0, _action.makeApiCallAction)('SET_MULTIPLE_LIMITS', _responsibleGaming2.default.setMultipleLimits(playerSessionID, limits));
};

exports.default = {
  getLimit: getLimit,
  setLimit: setLimit,
  getRealityCheckSession: getRealityCheckSession,
  getRealityCheckData: getRealityCheckData,
  deleteLimit: deleteLimit,
  selfBlock: selfBlock,
  selfExclude: selfExclude,
  toConfirm: toConfirm,
  confirm: confirm,
  decline: decline,
  blockProduct: blockProduct,
  getProductBlocks: getProductBlocks,
  panic: panic,
  pgsiScore: pgsiScore,
  limitIncreaseInfo: limitIncreaseInfo,
  setLimitWithToken: setLimitWithToken,
  getLimitWithToken: getLimitWithToken,
  getTableGamesSummary: getTableGamesSummary,
  setMultipleLimits: setMultipleLimits
};